// АВТОГЕНЕРАЦИЯ: не править вручную. Источник — .env (npm run sync:env).
export const environment = {
  "production": false,
  "billing": {
    "baseUrl": "https://dev.oldbilling.artelmik.ru",
    "token": "token2"
  },
  "billApi": {
    "baseUrl": "https://dev.bill.artelmik.ru"
  },
  "printer": {
    "host": "127.0.0.1",
    "port": "9123",
    "baseUrl": "http://127.0.0.1:9123"
  },
  "payments": {
    "defaultEmail": "pay@artelmik.ru",
    "maxPaymentAmount": 50000
  },
  "oauth": {
    "issuer": "https://dev.oauth.pg19.ru",
    "authorizeUrl": "https://dev.oauth.pg19.ru/oauth/pay/authorize",
    "tokenUrl": "https://dev.oauth.pg19.ru/oauth/pay/token",
    "userinfoUrl": "https://dev.oauth.pg19.ru/oauth/pay/userinfo",
    "logoutUrl": "https://dev.oauth.pg19.ru/auth/logout",
    "clientId": "pay",
    "redirectUri": "https://dev.mikpay.artelmik.ru/auth/callback",
    "scope": "openid profile email"
  }
} as const;
